import { computed, Injectable, signal } from '@angular/core';

import { Toast } from '../../models/toast.model';

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts = computed(() => this._toasts());

  private _toasts = signal<Toast[]>([]);

  showToast(toast: Toast): Toast {
    this._toasts.update((list) => [ ...list, toast ]);

    if (toast.duration) {
      setTimeout(() => this.removeToast(toast), toast.duration * 1000);
    }

    return toast;
  }

  removeToast(toast: Toast): void {
    this._toasts.update((list) => list.filter((t) => t !== toast));
  }
}
